import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import displayError from '../../utilities/displayError';

const TextAreaField = ({
  input = {},
  meta = {},
  className = null,
  errorMessage = null,
  placeholder = null,
  attributes = {},
  showErrorOnChange = false,
  maxLength = 2000,
  height = 120
}) => {
  const { error, submitFailed, touched } = meta;
  const showError = !!((error && submitFailed) || (error && showErrorOnChange && touched));
  const { className: inputClassName, ...restOfInputs } = input;

  return (
    <div className={classNames('textarea-field', className)}>
      <textarea
        {...restOfInputs}
        className={classNames('form-control', inputClassName, { error: showError })}
        placeholder={placeholder}
        {...attributes}
        maxLength={maxLength}
        style={{ height: `${height}px` }}
      />
      { showError &&
        <p className="error text-danger text-small">
          {displayError(errorMessage, error) }
        </p>
      }
    </div>
  );
};

TextAreaField.propTypes = {
  input: PropTypes.object,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  attributes: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  showErrorOnChange: PropTypes.bool,
  maxLength: PropTypes.number,
  height: PropTypes.number
};

export default TextAreaField;
